import styled, { css } from "styled-components/macro";

/**
 * Shared styled components used across panel variant and module files.
 */

export const PanelCard = styled.div`
  background: white;
  border-radius: 1em;
  border-top: 2px solid ${({ theme }) => theme.colors.heroBlue};
  box-shadow: ${({ theme }) => theme.boxShadow.md};
  padding: ${({ theme }) => theme.spacing.md};
  display: flex;
  flex-direction: column;
  align-self: stretch;
`;

export const CardTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.heading};
`;

export const CardTitleIcon = styled.span`
  color: ${({ theme }) => theme.colors.heroBlue};
  margin-top: 2px;
  font-size: 1em;
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.glassBlue};
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
  margin: ${({ theme }) => `${theme.spacing.md} 0`};
`;

export const CTAButton = styled.a`
  width: 100%;
  display: block;
  text-align: center;
  text-decoration: none;
  padding: ${({ theme }) => `${theme.spacing.xs} ${theme.spacing.md}`};
  border-radius: 0.5em;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  ${({ variant, theme }) => {
    switch (variant) {
      case "danger":
        return css`
          background: ${theme.colors.errorRed};
          color: white;
          border: none;
        `;
      case "default":
        return css`
          background: ${theme.colors.background};
          color: ${theme.colors.heading};
          border: 1px solid ${theme.colors.gradientMedGrey};
        `;
      default:
        return css`
          background: ${theme.colors.heroBlue};
          color: white;
          border: none;
        `;
    }
  }}
`;

export const SecondaryCTAButton = styled.a`
  width: 100%;
  display: block;
  text-align: center;
  text-decoration: none;
  padding: ${({ theme }) => `${theme.spacing.xs} ${theme.spacing.md}`};
  border-radius: 0.5em;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
    background: ${({ theme }) => theme.colors.glassBlue};
  }
`;
